import React from "react";
import InfoBox from "common-ui-components/components/info-box/InfoBox";
import LineChart from "common-ui-components/components/line-chart/LineChart";
import AutoSizer from "common-ui-components/components/AutoSizer";

const softwareTypes = [
  {
    id: "Non Commercial",
    sourceKey: "Non Commercial Software",
    color: "#1d8bdf",
    data: [],
  },
  {
    id: "Commercial",
    sourceKey: "Commercial Software",
    color: "#00A165",
    data: [],
  },
  {
    id: "Prohibited",
    sourceKey: "Prohibited Software",
    color: "#F26553",
    data: [],
  },
];

const SoftwareTypeTrend = ({ trendData = {}, onFilterSelect }) => {
  const chartData = softwareTypes.map((type) => ({
    ...type,
    data: trendData[type.sourceKey] || [],
  }));

  return (
    <InfoBox header="Software Type Trend">
      <div
        style={{
          width: "92%",
          maxWidth: "1200px",
          minWidth: 0,
          margin: "0 auto",
          height: "280px",
          position: "relative",
          transition: "min-width 0.25s ease",
        }}
      >
        <AutoSizer>
          {({ width }) => (
            <LineChart
              width={width}
              height={280}
              data={chartData}
              onPointClick={(point) => onFilterSelect?.({ id: point.serieId })}
            />
          )}
        </AutoSizer>
      </div>
    </InfoBox>
  );
};

export default SoftwareTypeTrend;
